import { resolverIdentidadeCredorOriginario } from '@/components/LogoCredor/identidadeCredorOriginario';
import { acertoVisualizouHeaderDestaqueCredorOriginario } from '@/modules/events/acerto';

export interface DestaqueCredorOriginario {
  nome: string;
  inicial: string;
}

export interface DividaParaDestaqueOriginario {
  id?: number;
  codigoCredor?: number;
  credor: string;
  credorOrigem?: string | null;
  possuiComposicao?: boolean;
}

/** O back envia `credorOrigem` já higienizado, mas o dado vem do credor e pode chegar em branco. */
function nomeCredorOrigem(divida: DividaParaDestaqueOriginario): string | undefined {
  const nome = divida.credorOrigem?.trim();
  return nome === '' ? undefined : nome;
}

function ehOProprioAdministrador(nome: string, credor: string): boolean {
  return nome.toLowerCase() === credor.trim().toLowerCase();
}

/** Regras RN02 e RN03 de `docs/specs/destaque-credor-originario.md`. */
export function resolverDestaqueCredorOriginario(
  divida?: DividaParaDestaqueOriginario | null
): DestaqueCredorOriginario | undefined {
  if (divida == null || divida.possuiComposicao) {
    return undefined;
  }

  const nome = nomeCredorOrigem(divida);
  if (nome === undefined || ehOProprioAdministrador(nome, divida.credor)) {
    return undefined;
  }

  return {
    nome,
    inicial: nome.charAt(0).toUpperCase(),
  };
}

/**
 * Acompanha a cobertura do destaque depois da promoção (RN08): dispara para toda dívida com
 * `credorOrigem`, inclusive quando o destaque não é exibido, para que `header_destaque` meça quanto
 * da base com originário ainda cai no layout atual.
 */
export function dispararVisualizouHeaderDestaqueCredorOriginario(divida: DividaParaDestaqueOriginario): void {
  if (divida.id == null || divida.codigoCredor == null || nomeCredorOrigem(divida) === undefined) {
    return;
  }

  const destaque = resolverDestaqueCredorOriginario(divida);
  const exibiuNomeOriginario =
    destaque === undefined ? undefined : resolverIdentidadeCredorOriginario(destaque.nome).nome !== undefined;

  acertoVisualizouHeaderDestaqueCredorOriginario(
    {
      id: divida.id,
      codigoCredor: divida.codigoCredor,
      credor: divida.credor,
    },
    destaque !== undefined,
    destaque?.nome,
    exibiuNomeOriginario
  );
}
